import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { TEAM_SEASON_HIGHS } from "../../constants/routes";


import MultiSelectDropdown from "../MultiSelectDropdown";
import Pill from "../Pill";
import DropdownSelect from "../DropdownSelect";
import Pagination from "../Pagination";
import Spinner from "../Spinner";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import api from "../../utils/api";
import { useParams } from "react-router-dom";
import { useReportIssue } from "../../hooks/useReportIssue";
import { ReportIssueModal } from "../../components/ReportIssueModal";
import { useReactiveRef } from '../../utils/UseReactiveState';

interface TeamData {
    SportCode: string,
    TeamName: string,
    TeamCode: string,
    stat_mapping: {
      [key: string | number]: any;
    }
  }


const TeamSeasonHighsView = (props: { TeamData: TeamData | null | undefined }) => {
    const {sportsCode, teamCode} = useParams();
    const [currentPage, setCurrentPage, currentPageRef] = useReactiveRef<number>(0);
    const [itemsPerPage, setItemsPerPage, itemsPerPageRef] = useReactiveRef<number>(10);

    const [teamHighsRes, setTeamHighsRes, teamHighsResRef] = useReactiveRef<TeamHighsRes | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedFilters, setSelectedFilters] = useState<{ seasons: number[], substat: string[], stat: string[] }>({ seasons: [], substat: [], stat: [] });

    const [errorStatus, setErrorStatus] = useState<number | null>(null);
     const [currentDuration, setCurrentDuration] = useState("season")
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isLoading, setisLoading] = useState(false);

  const formatNumericValue = (value: any): string | number => {
    if (value === null || value === undefined) return '-';
    if (typeof value !== 'number') return value;
    
    if (Number.isInteger(value)) {
      return value;
    }
    
    return parseFloat(value.toFixed(2));
  };

    function handleDropdownChange(key: any, value: any) {
    const updatedFilters: any = { ...selectedFilters };
    if (key === "seasons" || key === "substat" || key === "stat") {
      updatedFilters[key] = updatedFilters[key].includes(value)
        ? updatedFilters[key].filter((item: any) => item !== value)
        : [...updatedFilters[key], value];
    }

    
    setSelectedFilters(updatedFilters);
    if (!teamHighsRes?.TeamHighs.length) return;
    }

    
 
  const handleDeleteFilter = (filter: string) => {
    if (selectedFilters?.seasons.includes(parseInt(filter))) {
      setSelectedFilters({ 
        ...selectedFilters, 
        seasons: selectedFilters.seasons.filter((season) => season !== parseInt(filter)) 
      });
      setCurrentPage(0);
      return;
    }

    const isStatCategory = selectedFilters?.stat?.includes(filter);
    
    if (isStatCategory) {
      const categoryStats = props?.TeamData?.stat_mapping?.[filter] || [];
      const updatedStat = selectedFilters.stat.filter((s: string) => s !== filter);
      const updatedSubstat = selectedFilters.substat.filter(
        (substat: string) => !categoryStats.includes(substat)
      );
      
      setSelectedFilters({
        ...selectedFilters,
        stat: updatedStat,
        substat: updatedSubstat
      });
      setCurrentPage(0);
      return;
    }

    if (selectedFilters?.substat?.includes(filter)) {
      setSelectedFilters({
        ...selectedFilters,
        substat: selectedFilters.substat.filter((s: string) => s !== filter)
      });
      setCurrentPage(0);
      return;
    }
  };

  const getTeamHighs = async (duration:"season") => {
    try{
        setisLoading(true);
        const payload = {
            "SportCode": sportsCode,
            "TeamCode": teamCode,
           "StatPeriod": duration,
           "Limit": itemsPerPageRef.current,
            "Offset": currentPageRef.current * itemsPerPageRef.current,
    }

    const teamHighsRes:{data: TeamHighsRes} = await api.post(TEAM_SEASON_HIGHS, payload);
    console.log("team highs res",teamHighsRes);
    setTeamHighsRes(teamHighsRes.data);
    setLoading(false);
    if(teamHighsRes.data?.TeamHighs){
        teamHighsRes.data.TeamHighs = teamHighsRes.data.TeamHighs.map((teamHighs:any) => {
            const formattedHighs: any = {};
            Object.keys(teamHighs).forEach((key) => {
                formattedHighs[key] = formatNumericValue(teamHighs[key]);
            });
            return formattedHighs;
        });
        setTeamHighsRes(teamHighsRes.data);
    }
    }catch (err: any) { 
      console.log("Error msg in season and player highs")
      setErrorStatus(err?.response?.status ?? 500);
      setErrorMessage(err?.response?.data?.detail || "Something went wrong while fetching player records.");
    }
    finally {
      setisLoading(false);
    }
    };
    const handleClearAllFilters = () => {
    setSelectedFilters({ seasons: [], substat: [], stat: [] });
  };

   const getFilteredRowData = (): any[] => {
    return ((teamHighsRes?.TeamHighs ?? []) as any)
      .filter((teamHigh: TeamHigh) => selectedFilters.seasons.length > 0 ? selectedFilters.seasons.includes(teamHigh.season) : true)
      .filter((teamHigh: TeamHigh) => {
        if (!selectedFilters.stat.length) return true;
        const allStats: string[] = selectedFilters.stat.map((stat: string) => {
          const categoryStats: string[] | undefined = props?.TeamData?.stat_mapping?.[stat];
          return categoryStats ?? [];
        }).flat();
        return allStats.includes(teamHigh.stat);
      })
      .filter((teamHigh: TeamHigh) => {
        if (!selectedFilters.substat.length) return true;
        return selectedFilters.substat.includes(teamHigh.stat)
      });
  }

  const getColumnDefs = () => {
const allColumns = [
      { field: "season", sortable: true },
      { field: "stat", headerName: "Stat Names", sortable: true },
      { field: "value", headerName: "Value", sortable: true },
      { 
        field: "game_date", 
        headerName: "Game Date", 
        sortable: true,
      },
      { field: "opponent_team_name", headerName: "Opponent Team Name", sortable: true },
    ];
    return allColumns;
  };
useEffect(() => {
  if (!sportsCode || !teamCode) return;
  getTeamHighs(currentDuration);
}, [sportsCode, teamCode, currentDuration]);


      useEffect(() => {
        console.warn("setting page to 1");
        setCurrentPage(0);
      }, [selectedFilters]);
      const reportIssue = useReportIssue();


    const handleReportIssue = (errorContext?: string) => {
    console.log('Report issue clicked!');
    reportIssue.openModal({
      ComponentSource: 'PlayerDashboard - Season And Highs View',
      ErrorContext: errorContext || errorMessage || '',
      UserContext: {
        sportsCode,
        errorStatus,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
      },
    });
  };
    return (
        <>
        <div className="flex flex-row justify-between items-start">
            <div className="flex flex-row justify-start items-center gap-2 w-full">
                <div className="text-sm font-medium">Filters:-</div>
                <div className="flex gap-2 flex-wrap max-w-[40rem] px-2">
                     {([...selectedFilters.stat, ...selectedFilters.seasons, ...selectedFilters.substat])
                        .map((filter, index) => (
                            <Pill
                            key={index}
                            text={String(filter)}
                            showCross={true}
                            onClick={() => handleDeleteFilter(String(filter))}
                            />
                        ))}
                </div>
                  {(selectedFilters.stat.length || selectedFilters.seasons.length || selectedFilters.substat.length) > 0 && (
            <button
              onClick={handleClearAllFilters}
              className="ml-2 text-xs text-red-600 hover:text-red-800 underline whitespace-nowrap"
            >
              Clear All
            </button>
          )}
            </div>
          <div className="flex flex-row justify-between gap-2 w-full mb-2 min-w-[40rem] self-start">
          <MultiSelectDropdown
              options={Array.from(new Set(teamHighsRes?.TeamHighs.map((teamHigh:any) => teamHigh.season)))}
              options2={[]}
              def="Select Season"
              setSelectedOption={handleDropdownChange}
              selectedOption={selectedFilters}
              filterKey="seasons"
              disabled={false}
            />
          <MultiSelectDropdown
            options={Object.keys(props?.TeamData?.stat_mapping ?? {}) ?? []}
            options2={[]}
            def="Select Category"
            setSelectedOption={handleDropdownChange}
            selectedOption={selectedFilters}
            filterKey="stat"
            disabled={false}
          />
          <MultiSelectDropdown
            options={selectedFilters.stat.map((stat) => props?.TeamData?.stat_mapping?.[stat]).flat()}
            options2={[]}
            def="Select Substat"
            setSelectedOption={handleDropdownChange}
            selectedOption={selectedFilters}
            filterKey="substat"
            disabled={!selectedFilters.stat}
          />
          </div>

        </div>
            
            <div className="w-full overflow-x-auto rounded-lg">
                <div className="ag-theme-alpine" style={{ height: "500px", width: "100%" }}>
                      {errorMessage && errorStatus >= 500 ? (
          <div className="bg-red-50 text-red-700 p-4 rounded text-sm mb-4">
            {errorMessage}{" "}
            <button
              className="underline text-blue-600 hover:text-blue-800"
              onClick={() =>
                handleReportIssue(
                  `Failed to fetch  profile ( SportCode: ${sportsCode}, HTTP ${errorStatus})`
                )
              }
            >
              Click here to report this issue
            </button>
          </div>
        ) : (
            <>
            <AgGridReact
             rowData={getFilteredRowData()}
              columnDefs={getColumnDefs()}
              defaultColDef={{
                flex: 1,
                sortable: true,
                valueFormatter: (params) => {
                  const val = params.value;
                  return val === null || val === undefined ? "-" : val;
                },
                comparator: (valueA, valueB) => {
                  const isADash = valueA === "-" || valueA === null || valueA === undefined;
                  const isBDash = valueB === "-" || valueB === null || valueB === undefined;
                  
                  if (isADash && isBDash) return 0;
                  if (isADash) return 1;
                  if (isBDash) return -1;
                  
                  // STRICT CHECK: Only parse as number if string is purely numeric (no hyphens)
                  // This prevents "2025-10-11" from being parsed as "2025"
                  const isNumericString = (val: any) => /^-?\d*\.?\d+$/.test(String(val));

                  if (isNumericString(valueA) && isNumericString(valueB)) {
                    return parseFloat(String(valueA)) - parseFloat(String(valueB));
                  }
                  
                  return String(valueA).localeCompare(String(valueB));
                },
              }}
              pagination={true}
              paginationPageSize={itemsPerPage}
              paginationPageSizeSelector={[10, 25, 50, 100]}
              theme={themeQuartz}
              loadingOverlayComponent={Spinner}
              loading={isLoading}
            />
            </>
        )}
                </div>
            </div>
              <ReportIssueModal
                isOpen={reportIssue.isModalOpen}
                onClose={reportIssue.closeModal}
                onSubmit={reportIssue.handleSubmit}
                issue={reportIssue.issue}
                setIssue={reportIssue.setIssue}
                feedbackMessage={reportIssue.feedbackMessage}
                feedbackType={reportIssue.feedbackType}
                isLoading={reportIssue.isLoading}
              />
        </>
    );
}
export default TeamSeasonHighsView;